/**
 * EventBrella Customer UI — marketing site
 */

import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import EventBrellaHome from './components/eventbrella/EventBrellaHome';
import EventBrellaRoi from './components/eventbrella/EventBrellaRoi';
import EventBrellaFees from './components/eventbrella/EventBrellaFees';
import EventBrellaPlatform from './components/eventbrella/EventBrellaPlatform';
import EventBrellaRevenue from './components/eventbrella/EventBrellaRevenue';
import EventBrellaWhatYouGet from './components/eventbrella/EventBrellaWhatYouGet';
import EventBrellaFaq from './components/eventbrella/EventBrellaFaq';
import EventBrellaCalculatorPage from './components/eventbrella/EventBrellaCalculatorPage';
import EventBrellaTheExperience from './components/eventbrella/EventBrellaTheExperience';

const App = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<EventBrellaHome />} />
      <Route path="/roi" element={<EventBrellaRoi />} />
      <Route path="/fees" element={<EventBrellaFees />} />
      <Route path="/platform" element={<EventBrellaPlatform />} />
      <Route path="/revenue" element={<EventBrellaRevenue />} />
      <Route path="/what-you-get" element={<EventBrellaWhatYouGet />} />
      <Route path="/faq" element={<EventBrellaFaq />} />
      <Route path="/calculator/events" element={<EventBrellaCalculatorPage />} />
      <Route path="/theexperience" element={<EventBrellaTheExperience />} />
    </Routes>
  </BrowserRouter>
);

export default App;
